import { SUPPORTED_LANGUAGES } from "@/config/config";
import { NotFound } from "@/pages/errorPages/notFound";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

// Supported languages

// Validate language parameter
const langSchema = z.object({
  lang: z.enum(SUPPORTED_LANGUAGES),
});

function LanguageLayout() {
  const { lang } = Route.useParams();
  const { i18n } = useTranslation();

  // Update i18n language when route language changes
  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    // Store language preference
    localStorage.setItem("lang", lang);
  }, [lang, i18n]);

  return <Outlet />;
}

export const Route = createFileRoute("/$lang")({
  component: LanguageLayout,
  validateSearch: () => ({}), // Allow any search params to pass through
  beforeLoad: ({ params }) => {
    const parseResult = langSchema.safeParse(params);

    if (!parseResult.success) {
      // Invalid language, redirect to English
      throw redirect({
        to: "/$lang",
        params: { lang: "en" },
      });
    }
  },
  notFoundComponent: NotFound,
});
